export const zoomOnPadding = {
    top: 20,
    bottom: 20,
    left: 20,
    right: 20
};